const KEEP_CAPS = new Set(["CPA", "CPC", "CTR", "ROAS", "GHL", "LSA", "SEO", "PPC", "GBP", "CRM", "AI", "KPI", "LER"]);
// Older rows saved before the titles were reworded (2026-10-02) keep their Title Case prefixes.
const OLD_PREFIX: [RegExp, string][] = [[/^Agency-Wide Monthly LER:/, "Agency monthly LER:"], [/^Call Center Report:/, "Call center report:"]];
/** "CPA SPIKE detected — X" → "CPA spike detected: X": shouting words become words, acronyms stay, no em dashes. */
export const tidyTitle = (t: string) =>
  OLD_PREFIX.reduce((s, [re, to]) => s.replace(re, to), t)
    .replace(/\b[A-Z]{3,}\b/g, (w, i) => (KEEP_CAPS.has(w) ? w : i === 0 ? w.charAt(0) + w.slice(1).toLowerCase() : w.toLowerCase()))
    .replace(/^([a-z])/, (c) => c.toUpperCase())
    .replace(/\s+—\s+/g, ": ");
/** On a client's own page, the trailing ": Client name" (or " — Client name") says nothing. */
export const withoutClient = (title: string, client: string) => {
  const t = tidyTitle(title);
  const tail = `: ${client}`;
  return t.endsWith(tail) ? t.slice(0, -tail.length) : t;
};
/** A name people wrote with " — " (prompt names) reads "Name: detail" on screen; the stored text is left as written. */
export const noDash = (t: string | null | undefined) => String(t ?? "").replace(/\s+[—–]\s+/g, ": ");
